import { DateRangeFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';
import { ReactElement } from 'react';
import { UserRole } from '@synergy/models';

import { AccessControl } from '../../../common/components/access-control/access-control';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';
import { OrderTypeFilter } from '../../../common/components/filter/order-type-filter';
import { SupplierFilter } from '../../../common/components/filter/supplier-filter';

/** The filters the order list's endpoint takes; the list header owns the search. */
export const PaloOrdersFilter = (): ReactElement => (
    <PaloFilterModal>
        <DateRangeFilter untilField="createdAtUntil" fromField="createdAtFrom" />
        <SupplierFilter />
        <AccessControl allowedRoles={UserRole.ShopAdmin}>
            <CustomerContactFilter />
        </AccessControl>
        <OrderTypeFilter />
    </PaloFilterModal>
);
